import React, { FC, useState, useEffect, useContext } from 'react'
import history from '../../../history'

import { isMobile } from 'react-device-detect'

import { checkUserSubscriptionStatus } from '../../../Api/backendApi'
import moment from 'moment'

import GenericTextSpan from '../../../GenericComponents/GenericTextSpan'
import GenericRow from '../../../GenericComponents/GenericRow'
import GenericButton from '../../../GenericComponents/GenericButton'
import GenericCloseButton from '../../../GenericComponents/GenericCloseButton'
import GenericCard from '../../../GenericComponents/GenericMainCard'
import GenericColumn from '../../../GenericComponents/GenericColumn'

interface NewSubPromoModalnterface {
  closeModal: Function
  promoInfo: any
  redirectUserToPromoSubSelect: Function
  landing?: boolean
}

const NewSubPromoModal: FC<NewSubPromoModalnterface> = ({
  closeModal,
  promoInfo,
  redirectUserToPromoSubSelect,
  landing,
}) => {
  const [subInfo, setSubInfo] = useState<any>()

  useEffect(() => {
    !landing && handleCheckUserSubscription()
  }, [])

  const handleCheckUserSubscription = async () => {
    const sub: any = await checkUserSubscriptionStatus()

    if (sub && sub.subscription) {
      setSubInfo(sub.subscription)
    }
  }

  return (
    <GenericCard
      flexDir={'column'}
      className="promo-modal"
      width={'100%'}
      margin={' auto'}
    >
      <GenericCloseButton
        className="promo-modal-close-btn"
        onClick={closeModal}
      />

      {(promoInfo.promo_status == 'PROMO_DIALOG' ||
        (promoInfo &&
          promoInfo.promo_status &&
          promoInfo.promo_status == 'MIAZGA_NUTSHELL') ||
        promoInfo.promo_status == 'MIAZGA_NUTSHELL_AND_PROMO_DIALOG') && (
        <>
          <GenericRow margin={'0% 0 1% 0'}>
            <GenericTextSpan
              fSize={isMobile ? '1.9rem' : '2.5rem'}
              fWeight={'bold'}
            >
              {promoInfo.promo_status == 'MIAZGA_NUTSHELL'
                ? 'Promocja MIAZGA W PIGUŁCE'
                : promoInfo.promo_status == 'MIAZGA_NUTSHELL_AND_PROMO_DIALOG'
                ? 'Promocja MIAZGA W PIGUŁCE i Promocja MIAZGI'
                : 'Promocja MIAZGI'}
            </GenericTextSpan>
          </GenericRow>
          <GenericRow margin={'0% 0 1% 0'}>
            <GenericTextSpan
              fSize={isMobile ? '3.5rem' : '5rem'}
              fWeight={'bold'}
              color="#E39401"
            >
              TRWA!
            </GenericTextSpan>
          </GenericRow>

          <GenericRow margin={'10% 0 3% 0'}>
            <GenericColumn width="33%">
              <GenericRow margin="1.5% 0 1.5% 0" justify="flex-start">
                <GenericTextSpan
                  tAlign="left"
                  fSize={
                    window.innerWidth < 1400 && !isMobile
                      ? '1.5rem'
                      : isMobile
                      ? '1.3rem'
                      : '1.9rem'
                  }
                >
                  {promoInfo.promo_status == 'MIAZGA_NUTSHELL'
                    ? 'MIAZGA w pigułce'
                    : '2 miesiące'}
                </GenericTextSpan>
              </GenericRow>
              <GenericRow margin="1.5% 0 1.5% 0" justify="flex-start">
                <GenericTextSpan
                  tAlign="left"
                  fSize={
                    window.innerWidth < 1400 && !isMobile
                      ? '1.5rem'
                      : isMobile
                      ? '1.3rem'
                      : '1.9rem'
                  }
                >
                  {promoInfo.promo_status == 'MIAZGA_NUTSHELL'
                    ? 'vol. 1'
                    : 'w cenie jednego'}
                </GenericTextSpan>
              </GenericRow>
            </GenericColumn>
            <GenericColumn width="33%">
              <GenericRow align="flex-start">
                <GenericTextSpan
                  className="strikethrough"
                  color="#A1FB68"
                  fSize={
                    window.innerWidth < 1400 && !isMobile
                      ? '2rem'
                      : isMobile
                      ? '1.6rem'
                      : '2.5rem'
                  }
                  display="block"
                >
                  {promoInfo.promo_status == 'MIAZGA_NUTSHELL'
                    ? '249,99'
                    : '139,99'}
                </GenericTextSpan>
                <GenericTextSpan
                  color="#A1FB68"
                  fSize={window.innerWidth < 1400 ? '0.9rem' : '1.2rem'}
                >
                  zł
                </GenericTextSpan>
              </GenericRow>
            </GenericColumn>
            <GenericColumn width="33%">
              <GenericRow justify="flex-start" align="flex-start">
                <GenericTextSpan
                  color="#A1FB68"
                  fSize={
                    window.innerWidth < 1400 && !isMobile
                      ? '3.5rem'
                      : isMobile
                      ? '2.7rem'
                      : '4.3rem'
                  }
                >
                  {promoInfo.promo_status == 'MIAZGA_NUTSHELL'
                    ? '149,99'
                    : '69,99'}
                </GenericTextSpan>
                <GenericTextSpan
                  color="#A1FB68"
                  fSize={window.innerWidth < 1400 ? '1.3rem' : '1.7rem'}
                >
                  zł
                </GenericTextSpan>
              </GenericRow>
            </GenericColumn>
          </GenericRow>

          <GenericRow margin={'5% 0 3% 0'}>
            <GenericColumn width="33%">
              <GenericRow margin="1.5% 0 1.5% 0" justify="flex-start">
                <GenericTextSpan
                  tAlign="left"
                  fSize={
                    window.innerWidth < 1400 && !isMobile
                      ? '1.5rem'
                      : isMobile
                      ? '1.3rem'
                      : '1.9rem'
                  }
                >
                  {promoInfo.promo_status == 'MIAZGA_NUTSHELL'
                    ? 'MIAZGA w pigułce'
                    : 'Pół roku w cenie'}
                </GenericTextSpan>
              </GenericRow>
              <GenericRow margin="1.5% 0 1.5% 0" justify="flex-start">
                <GenericTextSpan
                  tAlign="left"
                  fSize={
                    window.innerWidth < 1400 && !isMobile
                      ? '1.5rem'
                      : isMobile
                      ? '1.3rem'
                      : '1.9rem'
                  }
                >
                  {promoInfo.promo_status == 'MIAZGA_NUTSHELL'
                    ? 'vol. 2'
                    : 'niecałych trzech'}
                </GenericTextSpan>
              </GenericRow>
              <GenericRow margin="1.5% 0 1.5% 0" justify="flex-start">
                <GenericTextSpan
                  tAlign="left"
                  fSize={
                    window.innerWidth < 1400 && !isMobile
                      ? '1.5rem'
                      : isMobile
                      ? '1.3rem'
                      : '1.9rem'
                  }
                >
                  {promoInfo.promo_status == 'MIAZGA_NUTSHELL'
                    ? ''
                    : 'miesięcy'}
                </GenericTextSpan>
              </GenericRow>
            </GenericColumn>

            <GenericColumn width="33%">
              <GenericRow align="flex-start">
                <GenericTextSpan
                  className="strikethrough"
                  color="#A1FB68"
                  fSize={
                    window.innerWidth < 1400 && !isMobile
                      ? '2rem'
                      : isMobile
                      ? '1.6rem'
                      : '2.5rem'
                  }
                  display="block"
                >
                  {promoInfo.promo_status == 'MIAZGA_NUTSHELL'
                    ? '249,99'
                    : ' 419,94'}
                </GenericTextSpan>
                <GenericTextSpan color="#A1FB68" fSize="1.2rem">
                  zł
                </GenericTextSpan>
              </GenericRow>
            </GenericColumn>
            <GenericColumn width="33%">
              <GenericRow justify="flex-start" align="flex-start">
                <GenericTextSpan
                  color="#A1FB68"
                  fSize={
                    window.innerWidth < 1400 && !isMobile
                      ? '3.5rem'
                      : isMobile
                      ? '2.7rem'
                      : '4.3rem'
                  }
                >
                  {promoInfo.promo_status == 'MIAZGA_NUTSHELL'
                    ? '149,99'
                    : '199,99'}
                </GenericTextSpan>
                <GenericTextSpan
                  color="#A1FB68"
                  fSize={window.innerWidth < 1400 ? '1.3rem' : '1.7rem'}
                >
                  zł
                </GenericTextSpan>
              </GenericRow>
            </GenericColumn>
          </GenericRow>

          {promoInfo.promo_status == 'MIAZGA_NUTSHELL_AND_PROMO_DIALOG' && (
            <GenericRow margin={'2% 0 1% 0'}>
              <GenericColumn width="33%">
                {/* <GenericRow margin="1.5% 0 1.5% 0" justify="flex-start">
                  <GenericTextSpan
                    margin={'2% 0'}
                    color={'#E39401'}
                    tAlign="left"
                    fWeight={'800'}
                    fSize={
                      window.innerWidth < 1400 && !isMobile
                        ? '1.9rem'
                        : isMobile
                        ? '1.6rem'
                        : '2.2rem'
                    }
                  >
                    NOWOŚĆ
                  </GenericTextSpan>
                </GenericRow> */}
                <GenericRow margin=".5% 0 .5% 0" justify="flex-start">
                  <GenericTextSpan
                    fWeight={'500'}
                    tAlign="left"
                    fSize={
                      window.innerWidth < 1400 && !isMobile
                        ? '1.8rem'
                        : isMobile
                        ? '1.5rem'
                        : '2.1rem'
                    }
                  >
                    MIAZGA w pigułce
                  </GenericTextSpan>
                </GenericRow>
                <GenericRow margin=".5% 0 .5% 0" justify="flex-start">
                  <GenericTextSpan
                    tAlign="left"
                    fSize={
                      window.innerWidth < 1400 && !isMobile
                        ? '1.5rem'
                        : isMobile
                        ? '1.3rem'
                        : '1.9rem'
                    }
                  >
                    vol. 1
                  </GenericTextSpan>
                </GenericRow>
              </GenericColumn>

              <GenericColumn width="33%">
                <GenericRow align="flex-start">
                  <GenericTextSpan
                    className="strikethrough"
                    color="#A1FB68"
                    fSize={
                      window.innerWidth < 1400 && !isMobile
                        ? '2rem'
                        : isMobile
                        ? '1.6rem'
                        : '2.5rem'
                    }
                    display="block"
                  >
                    249,99
                  </GenericTextSpan>
                  <GenericTextSpan color="#A1FB68" fSize="1.2rem">
                    zł
                  </GenericTextSpan>
                </GenericRow>
              </GenericColumn>
              <GenericColumn width="33%">
                <GenericRow justify="flex-start" align="flex-start">
                  <GenericTextSpan
                    color="#A1FB68"
                    fSize={
                      window.innerWidth < 1400 && !isMobile
                        ? '3.5rem'
                        : isMobile
                        ? '2.7rem'
                        : '4.3rem'
                    }
                  >
                    149,99
                  </GenericTextSpan>
                  <GenericTextSpan
                    color="#A1FB68"
                    fSize={window.innerWidth < 1400 ? '1.3rem' : '1.7rem'}
                  >
                    zł
                  </GenericTextSpan>
                </GenericRow>
              </GenericColumn>
            </GenericRow>
          )}

          {promoInfo.promo_status == 'MIAZGA_NUTSHELL_AND_PROMO_DIALOG' && (
            <GenericRow margin={'2% 0 1% 0'}>
              <GenericColumn width="33%">
                {/* <GenericRow margin="1.5% 0 1.5% 0" justify="flex-start">
                  <GenericTextSpan
                    margin={'2% 0'}
                    color={'#E39401'}
                    tAlign="left"
                    fWeight={'800'}
                    fSize={
                      window.innerWidth < 1400 && !isMobile
                        ? '1.9rem'
                        : isMobile
                        ? '1.6rem'
                        : '2.2rem'
                    }
                  >
                    NOWOŚĆ
                  </GenericTextSpan>
                </GenericRow> */}
                <GenericRow margin=".5% 0 .5% 0" justify="flex-start">
                  <GenericTextSpan
                    fWeight={'500'}
                    tAlign="left"
                    fSize={
                      window.innerWidth < 1400 && !isMobile
                        ? '1.8rem'
                        : isMobile
                        ? '1.5rem'
                        : '2.1rem'
                    }
                  >
                    MIAZGA w pigułce
                  </GenericTextSpan>
                </GenericRow>
                <GenericRow margin=".5% 0 .5% 0" justify="flex-start">
                  <GenericTextSpan
                    tAlign="left"
                    fSize={
                      window.innerWidth < 1400 && !isMobile
                        ? '1.5rem'
                        : isMobile
                        ? '1.3rem'
                        : '1.9rem'
                    }
                  >
                    vol. 2
                  </GenericTextSpan>
                </GenericRow>
              </GenericColumn>

              <GenericColumn width="33%">
                <GenericRow align="flex-start">
                  <GenericTextSpan
                    className="strikethrough"
                    color="#A1FB68"
                    fSize={
                      window.innerWidth < 1400 && !isMobile
                        ? '2rem'
                        : isMobile
                        ? '1.6rem'
                        : '2.5rem'
                    }
                    display="block"
                  >
                    249,99
                  </GenericTextSpan>
                  <GenericTextSpan color="#A1FB68" fSize="1.2rem">
                    zł
                  </GenericTextSpan>
                </GenericRow>
              </GenericColumn>
              <GenericColumn width="33%">
                <GenericRow justify="flex-start" align="flex-start">
                  <GenericTextSpan
                    color="#A1FB68"
                    fSize={
                      window.innerWidth < 1400 && !isMobile
                        ? '3.5rem'
                        : isMobile
                        ? '2.7rem'
                        : '4.3rem'
                    }
                  >
                    149,99
                  </GenericTextSpan>
                  <GenericTextSpan
                    color="#A1FB68"
                    fSize={window.innerWidth < 1400 ? '1.3rem' : '1.7rem'}
                  >
                    zł
                  </GenericTextSpan>
                </GenericRow>
              </GenericColumn>
            </GenericRow>
          )}

          <GenericRow margin="2% 0 1.5% 0">
            <GenericButton
              margin="0 2% 0 2%"
              className="promo-outline-btn"
              width="45%"
              onClick={() => closeModal()}
            >
              ZREZYGNUJ
            </GenericButton>
            <GenericButton
              className="promo-fill-btn"
              margin="0 2% 0 2%"
              width="48%"
              onClick={() => redirectUserToPromoSubSelect()}
            >
              SKORZYSTAJ
            </GenericButton>
          </GenericRow>
        </>
      )}
      {promoInfo && promoInfo.promo_status == 'STRIPE_SUBSCRIPTION_ACTIVE' && (
        <>
          <GenericRow margin={'0% 0 1% 0'}>
            <GenericTextSpan
              fSize={isMobile ? '1.9rem' : '2.5rem'}
              fWeight={'bold'}
            >
              Promocja TRWA
            </GenericTextSpan>
          </GenericRow>
          <GenericRow margin={'0% 0 1% 0'}>
            <GenericTextSpan
              fSize={isMobile ? '1.5rem' : '2rem'}
              fWeight={'bold'}
              color="#E39401"
            >
              Promocja naliczy się automatycznie. Nie musisz nic robić!
            </GenericTextSpan>
          </GenericRow>
          {/* TODO:  data konca subskrypcji zamiast placeholdera */}
          <GenericColumn>
            <GenericTextSpan
              lineHeight="1.8rem"
              fSize="1.6rem"
              margin="5% 2% 0 5%"
            >
              Twoja subskrypcja jest aktywna i{' '}
              <b className="green">
                {' '}
                automatycznie odnowi się{' '}
                {subInfo &&
                  moment(subInfo.expiration_date).format('DD MMMM YYYY')}{' '}
              </b>
              na 2 miesiące w cenie 1!
            </GenericTextSpan>
            {/* <GenericTextSpan
              lineHeight="1.8rem"
              fSize="1.6rem"
              margin="3% 2% 0 8%"
            >
              Promocja zostanie dodana automatycznie 22 maja.
            </GenericTextSpan> */}
          </GenericColumn>

          <GenericRow margin="5% 0 1.5% 0">
            <GenericButton
              margin="0 2% 0 2%"
              className="promo-outline-btn"
              width="45%"
              onClick={() => closeModal()}
            >
              ROZUMIEM
            </GenericButton>
            {/* <GenericButton
              className="promo-fill-btn"
              margin="0 2% 0 2%"
              width="48%"
              onClick={() => redirectUserToPromoSubSelect()}
            >
              SKORZYSTAJ
            </GenericButton> */}
          </GenericRow>
        </>
      )}
    </GenericCard>
  )
}

export default NewSubPromoModal
